var map = {
	"./cnd_federal.png": 831,
	"./cnd_municipal.png": 832,
	"./emails_caixa_postal.png": 833,
	"./extrato_dctf.png": 834,
	"./guias.png": 835,
	"./iptu.png": 836,
	"./processos.png": 837,
	"./relação_de_darfs_pagos.png": 838,
	"./relação_de_nfs.png": 839,
	"./situacao_fiscal.png": 840
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 830;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loja ^\.\/.*$
// module id = 830
// module chunks = 0